import styled from "styled-components";
import { css } from "styled-components";

export const GiftCardsTableRoot = styled.div(
    () => css`
        .PaginatedTable.TableRoot {
            .TableHead {
                .TableHeader {
                    // Columna de términos y condiciones
                    &:nth-child(3),
                    &:nth-child(4),
                    &:nth-child(5),
                    &:nth-child(6),
                    &:nth-child(7) {
                        > div {
                            justify-content: center;
                            align-items: center;
                        }
                    }
                }
            }
        }
    `,
);
